import React from "react";
import { Helmet } from "react-helmet-async";

import Album from "components/pages/HomePage/Album";
import ContactForm from "components/common/ContactForm";
import Courses from "components/pages/HomePage/Courses";
import EarlyEducation from "components/pages/HomePage/EarlyEducation";
import HeroBanner from "components/pages/HomePage/HeroBanner";
import Stack from "@mui/material/Stack";
import Testimonials from "components/pages/HomePage/Testimonials";
import WhyUs from "components/pages/HomePage/WhyUs";

function HomePage() {
  return (
    <Stack spacing={10}>
      <Helmet>
        <title>Trang chủ - The English Tree</title>
        <meta
          name="description"
          content="Chương trình tiếng Anh toàn diện, chú trọng 4 kỹ năng NGHE - NÓI - ĐỌC - VIẾT và phát triển song song nhiều KỸ NĂNG MỀM giúp trẻ tự tin – năng động."
        />
        <link rel="canonical" href="https://englishtree.edu.vn" />
      </Helmet>

      <HeroBanner />
      <Courses />
      <ContactForm />
      <Testimonials />
      <EarlyEducation />
      <WhyUs />
      <Album />
    </Stack>
  );
}

HomePage.propTypes = {};

export default HomePage;
